import { apiDomain, warName } from "..";
import { appConfig } from "../appConfig";
import { getConfiguration } from './utils/configuration';
import { getCookie } from './utils/getCookie';
import $ from 'jquery';
import { getQueryStringVariable } from "./utils/getQueryStringVariable";

function appendScript(url, containerId) {
    if (!$(`script[src="${url}"]`).length) {
        if ((containerId || null) == null) {
            $('head').append(`<script src="${url}">`);
        } else {
            $(`<script src="${url}">`).insertAfter($(`#${containerId}`).find("script:last"));
            
        }
    }
}

function appendCSS(url, containerId, idLinkTag, attributes) {
    let attrs = '';
    if(typeof attributes == 'object') {
        try {
            Object.entries(attributes).forEach(function([k,v])
                {
                    attrs+=k+'="'+v+'"'
                }
            )
        }catch(err) {
            console.log(err)
        }
    }
    if (!$(`link[href="${url}"]`).length) {
        if ((containerId || null) == null) {
            $('head').append(`<link rel="stylesheet" href="${url}" id="${idLinkTag}" ${attrs} >`);
        } else {
            $(`<link rel="stylesheet" href="${url}" id="${idLinkTag}"  ${attrs} >`).insertAfter($(`#${containerId}`).find("link[rel='stylesheet']:last"));
            
        }
    }
}

function importCSS(url, containerId) {
    const _import = `@import "${url}";`
    if ((containerId || null) == null) {
        const style = $('head').children("style:first");
        if (!style.text().includes(_import)) {
            $(style).prepend(_import);
        }
    } else {
        const style = $(`#${containerId}`).children("style:first");
        if (!style.text().includes(_import)) {
            $(style).prepend(_import);
        }
    }
}

export function concatUrlPathnames(...pathnames) {
	if(!window.concatUrlPathnames){
		window.concatUrlPathnames = concatUrlPathnames;
	}
	
	var toReturn = '';
	if (pathnames) {
		if (pathnames.length === 1) {
			toReturn = pathnames[0]
		} else {
			pathnames.forEach(function(p) {
				if (p) {
					if (p.startsWith('/')) {
						if (toReturn.endsWith('/')) {
							toReturn += p.substring(1)
						} else {
							toReturn += p;
						}
					} else {
						if ((toReturn || null) == null || toReturn.endsWith('/')) {
							toReturn += p;
						} else {
							toReturn += '/' + p;
						}
					}
				}
			});
		}
		
	}
	return removeMultipleSlashes(toReturn);
}


export function removeMultipleSlashes(pathname) {
	let toReturn = pathname;

	if(toReturn) {
		toReturn = toReturn.replace(/\/+/mg,"/");
	}

	return toReturn;
}

export function arePathnamesEqual(pathname1, pathname2) {
	let p1 = pathname1;
	let p2 = pathname2;
	const slash = '/';
	if (pathname1.endsWith(slash) && !pathname2.endsWith(slash)) {
		p2 = p2 + slash;
	} else if (!pathname1.endsWith(slash) && pathname2.endsWith(slash)) {
		p1 = p1 + slash;
	}
	return p1 === p2;
}

export function isBotAgent(){
	var botPattern = "(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|Prerender)";
	var re = new RegExp(botPattern, 'i');
	var userAgent = navigator.userAgent; 

	/*if (re.test(userAgent)) {
    	console.log('the user agent is a crawler!');
	}*/
	return re.test(userAgent);
}

function screenCenteredPosition(w, h) {
	// Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;

	return {
		top:top,
		left:left
	}
}

export function openPopup(url, title, w, h) {
	const width = w || 700;
	const height = h || 700;
	const position = screenCenteredPosition(width, height);
    const params = [
        'scrollbars=no',
        'resizable=yes',
        'status=no',
        'location=no',
        'toolbar=no',
        'menubar=no',
        `top=${position.top}`,
        `left=${position.left}`,
        `width=${width}`,
        `height=${height}`,
    ].join(',');
	
	window.open(url, title, params);
}

export function initStatsUtils() {
    $(document).on('click', '.stat-sel', function () {
        const url = $(this).data('stats-url');
        if (url?.length > 0) {
            openPopup(url, 'Match Stats');
        }
    });
}

export function setLiveEventsNumber(num) {
	$("#cg-live-button").find("#cg-live-events-number").text(num);
}
export function setBetslipEventsNumber(num) {
	const el = document.querySelector('#cg-betslip-button #cg-betslip');
    if (el == null) {
        return;
    }
	if (num) {
		el.innerText = num;
		el.classList.remove('hide');
		el.classList.remove('d-none');
	} else  {
        if(!el.classList.contains('hide')) {
			el.classList.add('hide');
		}
		if(!el.classList.contains('d-none')) {
			el.classList.add('d-none');
		}
	}
}

export function loadXSportDatastoreStaticResources(isMobile = false) {
	const containerId = appConfig['CONTAINER_ID'] || null;
	const configuration = getConfiguration();
	const version = configuration['ver'];
	const hrefCssDsk =  configuration['hfd'];
	const hrefCssMbl =  configuration['hfm'];
	// const hrefCssXShop = configuration['hfxs'];
	function handleCssDarkMode(hrefCss){
		const isDarkModeCookieSet = getCookie('cg-dark-mode') === 'true' || getQueryStringVariable('cg-dark-mode') == 'true' ;
		try {
			if(hrefCss && ( (appConfig?.['THEME'] && appConfig['THEME']['enabled']) || isDarkModeCookieSet ) ){
				const isDark = appConfig?.['THEME']?.['dark'] || isDarkModeCookieSet;
				if (!$(`style[id="xsp-style-dark"]`).length) {
					const indexOf = hrefCss.indexOf(".css");
					if(indexOf > 1){
						const style = `<style id="xsp-style-dark" class="xsp cg-dark-cssfile" >`;
						const hrefCssDark = hrefCss.substring(0,indexOf)+'_dark'+hrefCss.substring(indexOf);
						const _import = `@import "${hrefCssDark}?xsdv=${version}";`
						if ((containerId || null) == null) {
							$('head').append(style);
						}else{
							$(style).insertAfter($(`#${containerId}`).find("style:last"));
						}
						if (isDark){
							if($(`style[id="xsp-style-dark"]`).length){
								$(`style[id="xsp-style-dark"]`).prepend(_import);
							}
						}else{
							appendCSS(`${hrefCssDark}?xsdv=${version}`, containerId,'xsp_css_dark',{'class':'xsp cg-dark-cssfile','disabled':'disabled'});
						}
					}
				}
			}
		}catch(err) {
			console.error(err);
		}
	}

    appendCSS(`${apiDomain}/${warName}/content/sport-ico.css?xsdv=${version}`, containerId,'');
    appendCSS(`${apiDomain}/${warName}/content/flag-ico.css?xsdv=${version}`, containerId,'');
    appendScript(`${apiDomain}/${warName}/content/js/lib/barcode/JsBarcode.all.min.js`, containerId);
    if (!isMobile && (hrefCssDsk || null) !== null) {
        //appendCSS([hrefCssDsk,'?xsdv=',version].join(''),containerId,'');
        importCSS(`${hrefCssDsk}?xsdv=${version}`, containerId);
        handleCssDarkMode(hrefCssDsk);
    }

    if (isMobile && (hrefCssMbl || null) !== null) {
        //appendCSS([hrefCssMbl,'?xsdv=',version].join(''),containerId,'');
        appendCSS(`${hrefCssMbl}?xsdv=${version}`, containerId,'');
        handleCssDarkMode(hrefCssMbl);
    }
}

export function loadXShopExternalCss() {
	const containerId = appConfig['CONTAINER_ID'] || null;
	const configuration = getConfiguration();
	const version = configuration['ver'];
	const hrefCssXShop = configuration['hfxs'];
	if (hrefCssXShop) {
        appendCSS(`${hrefCssXShop}?xsdv=${version}`, containerId, 'xshop-external-css');
	}

}

export function loadXMonitorExternalCss() {
	const containerId = appConfig['CONTAINER_ID'] || null;
	const configuration = getConfiguration();
	const version = configuration['ver'];
	const hrefCssXMonitor = configuration['hfxm'];
	if (hrefCssXMonitor) {
        appendCSS(`${hrefCssXMonitor}?xsdv=${version}`, containerId, 'xmonitor-external-css');
	}
}

export function loadHTMLResource(url,containerId){
	if(url){
		//$('#'+containerId).load(url,function(){});
		load_resource(null,url,containerId);
	}else{
		$('#'+containerId).html('');
	}
}

export function setHTML(html,containerId){
	$('#'+containerId).html(html || '');
}

function load_resource (e,url,id) {
	const event = (e || window.event);
	if(event){
		event.preventDefault();
	}
	var con = document.getElementById(id)
	,   xhr = new XMLHttpRequest();
  
	xhr.onreadystatechange = function (e) { 
	  if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 304) ) {
		  if(con){
			con.innerHTML = xhr.responseText;
		  }
	  }
	}
  
	xhr.open("GET", url, true);
	xhr.setRequestHeader('Content-type', 'text/html');
	xhr.send();
}

export function handleHistory(path) {
	if (window.location.pathname !== path) {
		//console.log(window.location.pathname+"-->"+path)
		window.history.pushState(window.history.state, null, path);
	}	
	
}

export function getBannerTargetWindow(bannerUrl) {
    let targetWindow = '_blank'; 
	
    const getBaseDomain = (hostname) => {
        const parts = hostname.split('.');
        if (parts.length <= 2) {
            return hostname;
        }
        return parts.slice(-2).join('.');
    };

    try {
        const domain = new URL(bannerUrl);
        const bannerHostname = domain.hostname; 
        const currentHostname = window.location.hostname;
        if (getBaseDomain(bannerHostname) === getBaseDomain(currentHostname)) {
            targetWindow = '_self'; 
        }
    } catch (err) {
        targetWindow = '_self';
    }
    return targetWindow;
}

export function elementsOverlap(el1, el2) {
	const domRect1 = el1.getBoundingClientRect();
	const domRect2 = el2.getBoundingClientRect();
  
	return !(
	  domRect1.top > domRect2.bottom ||
	  domRect1.right < domRect2.left ||
	  domRect1.bottom < domRect2.top ||
	  domRect1.left > domRect2.right
	);
}

export function addDocumentRegionClickHandler(region='top',numClick=5,handler){
	
	var getArea = function(x,y){
		const screen = window.screen;
		//console.log(x);
		//console.log(y);
		var areas = {
			top: [0, 0, screen.width, 500], // [startX, startY, endX, endY]
			left: [0, 0, 500, screen.height],
			right: [screen.width-500, 0, screen.width, screen.height],
			bottom: [0, screen.height-500, screen.width, screen.height]
		};
		let toReturn = '';
		for (var key in areas) {
			var area = areas[key];
			if (x >= area[0] && x <= area[2] && y >= area[1] && y <= area[3]){
				if(key == region){
					return key;
				}
				toReturn+=(toReturn?','+key:key)
			}
		}
		return toReturn || null;
	}
	var timer = 0;
	var cntClick = 0;
	document.addEventListener("click", function(evt) {
		if(timer == 0) {
			cntClick++;
            timer = 1;
            timer = setTimeout(function(){ timer = 0; cntClick = 0; }, 800);
        }
        else { 
			cntClick++;
			if(cntClick == numClick){
				let matching = false;
				const clickedArea = getArea(evt.clientX, evt.clientY);
				const splitRegion = region.split(',',2);
				if(splitRegion.length <= 1 && clickedArea == region){
					matching = true;
				}else{
					const splitArea = clickedArea.includes(',') ? clickedArea.split(',',2):null;
					splitArea && splitRegion.forEach((v,i) => {
						if(splitArea.includes(v)){
							splitArea.splice(splitArea.indexOf(v), 1);
						}
					})
					if(splitArea?.length == 0){
						matching = true;
					}
				}
				if(matching && handler){
					handler();
				}
				timer = 0; 
				cntClick = 0;
			}
		}
	})
}

 export function onDoubleTouchEventHandler(region1='top',region2='bottom',duration=5000,handler){
	
	var getArea = function(x,y,region){
		const screen = window.screen;
		//console.log(x);
		//console.log(y);
		var areas = {
			top: [0, 0, screen.width, 500], // [startX, startY, endX, endY]
			left: [0, 0, 500, screen.height],
			right: [screen.width-500, 0, screen.width, screen.height],
			bottom: [0, screen.height-500, screen.width, screen.height]
		};
		let toReturn = '';
		for (var key in areas) {
			var area = areas[key];
			if (x >= area[0] && x <= area[2] && y >= area[1] && y <= area[3]){
				if(key == region){
					return key;
				}
				toReturn+=(toReturn?','+key:key)
			}
		}
		return toReturn || null;
	}

	var overlaps = function(area,region){
		let matching = false;
		const splitRegion = region.split(',',2);
		if(splitRegion.length <= 1 && area == region){
			matching = true;
		}else{
			const splitArea = area.includes(',') ? area.split(',',2):null;
			splitArea && splitRegion.forEach((v,i) => {
				if(splitArea.includes(v)){
					splitArea.splice(splitArea.indexOf(v), 1);
				}
			})
			if(splitArea?.length == 0){
				matching = true;
			}
		}
		return matching;
	}

	var timer = 0;
	var interval;
	var touchedRegion1 = false;
	var touchedRegion2 = false;
	var timeoutResetDoubleTouch = null;
	var resetDoubleTouch = function(){
		clearInterval(interval);
		timer = 0;
		touchedRegion1 = false;
		touchedRegion2 = false;
	}

	document.addEventListener("touchstart", function(evt) {
		//console.log("touch start");
		const clickedArea1 = evt.touches[0] && getArea(evt.touches[0].clientX, evt.touches[0].clientY,region1);
		const clickedArea2 = evt.touches[1] && getArea(evt.touches[1].clientX, evt.touches[1].clientY,region2);
		if(!timeoutResetDoubleTouch){
			touchedRegion1 = clickedArea1 && overlaps(clickedArea1,region1);
		}
		touchedRegion2 = clickedArea2 && overlaps(clickedArea2,region2);

		if(touchedRegion1 && touchedRegion2){
			interval = 
				setInterval(function()
				{ 
					if(timer >= duration) {
						if(handler){
							handler();
						}
						resetDoubleTouch();
					}else{
						timer+=1000 
					} 
				}, 1000);
		}else if(touchedRegion1 && timeoutResetDoubleTouch){
			touchedRegion2 = clickedArea1 && overlaps(clickedArea1,region2);
			if(touchedRegion2){
				interval = 
				setInterval(function()
				{ 
					if(timer >= duration) {
						if(handler){
							handler();
						}
						resetDoubleTouch();
					}else{
						timer+=1000 
					} 
				}, 1000);
			}
		}
	})

	document.addEventListener("touchend", function(evt) {
		//console.log("touch end");
		if(touchedRegion1 && touchedRegion2){
			resetDoubleTouch();
		}else if(touchedRegion1 && timeoutResetDoubleTouch){
			resetDoubleTouch();
			timeoutResetDoubleTouch = clearTimeout(timeoutResetDoubleTouch);
		}
		else{
			timeoutResetDoubleTouch = setTimeout(function(){  timeoutResetDoubleTouch = clearTimeout(timeoutResetDoubleTouch);}, 5000);
		}
	})
}